<div class="panel" fxLayout="row" fxLayoutAlign="start center">
  <button mat-icon-button (click)="clickPrevYear()">
    <mat-icon [svgIcon]="Icons.ChevronLeft"></mat-icon>
  </button>
  <div fxFlex></div>
  <button mat-icon-button (click)="clickNextYear()" [disabled]="!canClickNextYear()">
    <mat-icon [svgIcon]="Icons.ChevronRight"></mat-icon>
  </button>
</div>
